export * from './market-type-config-detail';
